'use client';

import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
import { FC } from 'react';
import { ContentCard } from '../../styles';
import { IHousingObjectResponse } from '@/types';

const PropertyDetailMap = dynamic(
  () => import('@/components/shared/PropertyDetailMap').then((m) => m.PropertyDetailMap),
  { ssr: false },
);

type MapProps = {
  data?: IHousingObjectResponse;
  isProject?: boolean;
};

export const Map: FC<MapProps> = ({ data, isProject }) => {
  const t = useTranslations();

  const isCoordinateExist = data?.longitude && data?.latitude;

  if (!data || !isCoordinateExist) return null;

  const price = isProject
    ? (() => {
        const pd = data.projectData;
        const from = Math.min(pd?.priceFrom ?? Infinity, pd?.rentFrom ?? Infinity);
        return isFinite(from) ? from : undefined;
      })()
    : data.sell
      ? (data.prices?.sellPriceNumeric ?? undefined)
      : (data.prices?.monthlyCostsNumeric ?? data.prices?.grossRentNumeric ?? undefined);

  return (
    <ContentCard>
      <Typography fontWeight={600} fontSize={24} lineHeight={'34px'}>
        {t('housingCardDetails.map')}
      </Typography>
      <PropertyDetailMap
        lat={data.latitude}
        lng={data.longitude}
        mapCircleRadius={data.mapCircleRadius}
        price={price}
        isProject={isProject}
      />
    </ContentCard>
  );
};
